import { render, staticRenderFns } from "./editPost.vue?vue&type=template&id=28a222d0&"
import script from "./editPost.vue?vue&type=script&lang=js&"
export * from "./editPost.vue?vue&type=script&lang=js&"
import style0 from "./editPost.vue?vue&type=style&index=0&id=28a222d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports